import json from '../package.json';
export const NODE_ENV = process.env?.NODE_ENV?.trim()?.toLowerCase();

export const port = Number(process.env.PORT) || json.config.port || 8080;
export const isProd = NODE_ENV === 'production';
export const API_ENDPOINT = '/api';
